import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from "react-native";
// import Icon from 'react-native-ionicons';
import { Ionicons as Icon } from '@expo/vector-icons';
import AsyncStorage from '@react-native-async-storage/async-storage';


import { debounce } from 'lodash';
import CallRepSearchInput from '../CallRepSearchInput';
import Colors from '../../constants/Colors'
import FontStyles from '../../constants/FontStyle';
import HeaderGradient from './HeaderGradient';


const CallRepHeader = function ({ navigation, route, setQueryString }) {
    const [query, setQuery] = React.useState('')
    const debounceHandler = React.useMemo(() => debounce(setQueryString, 800), [])

    const execQuery = (queryString) => {
        // const count = queryString.split('').length
        // if (count < 3) {
        //     return
        // }
        debounceHandler(queryString)
    }

    return (
        <HeaderGradient>
            <View style={styles.container}>

                <View style={{
                    flexDirection: 'row',
                }}>
                    <TouchableOpacity style={{
                        paddingLeft: 16,
                        paddingRight: 22,
                        paddingVertical: 15,
                        alignSelf: 'center'
                    }}
                        onPress={() => navigation.navigate('Home')}>
                        <Icon name="md-arrow-back" color='#FFFFFF' size={24} />
                    </TouchableOpacity>
                    <View style={{
                        flexGrow: 1,
                        paddingBottom: 18,
                        paddingTop: 20,
                    }}>
                        <Text style={{
                            height: 20,
                            color: Colors.whiteColor,
                            ...FontStyles.size17,
                            ...FontStyles.lh20,
                            ...FontStyles.bold,
                        }}>Select Manufacturer</Text>
                    </View>
                    <TouchableOpacity style={{
                        paddingHorizontal: 16,
                        paddingVertical: 15,
                        alignSelf: 'center'
                    }}
                        onPress={() => { }}>
                        <Icon name="md-more" color='#FFFFFF' size={24} />
                    </TouchableOpacity>
                </View>
                <CallRepSearchInput style={styles.searchBox}
                    iconProps={{
                        name: 'md-search'
                    }}
                    inputProps={{
                        value: query,
                        onChangeText: (text) => {
                            setQuery(text)
                            execQuery(text)
                        },
                        placeholder: 'Search manufacturer'
                    }}
                />
            </View>
        </HeaderGradient>
    )
}

export default CallRepHeader

const styles = StyleSheet.create({
    container: {
        flexDirection: 'column',
        paddingBottom: 20,
        paddingHorizontal: 16,
    },
    searchBox: {
        flexGrow: 1
    },
    topBar: {
        // flex: 1,
        flexDirection: "row",
    },
    salute: {
        // width: 118,
        height: 21,
        opacity: .6,
        color: Colors.whiteColor,
        ...FontStyles.size18,
        ...FontStyles.lh22,
        ...FontStyles.bold,
        marginBottom: 3,
    },
    storeName: {
        color: Colors.whiteColor,
        ...FontStyles.size18,
        ...FontStyles.lh22,
        ...FontStyles.bold,
        // width: 178,
        height: 21,
    }
})